import featureBannerServiceAPIClient from '@/services/toolbox/feature-banner-service';

const state = {
	dashboard: {
		loadingStatus: false,
		error: '',
		highlightCards: [],
	},
	brandBuilder: {
		loadingStatus: false,
		error: '',
		highlightCards: [],
	},
};

const mutations = {
	// dashboard banner mutations
	SET_DASHBOARD_BANNERS_LOADING_STATUS(state, status) {
		state.dashboard.loadingStatus = status;
	},
	SET_DASHBOARD_BANNERS_ERROR(state, message) {
		state.dashboard.error = message;
	},
	CLEAR_DASHBOARD_BANNERS_ERROR(state) {
		state.dashboard.error = '';
	},
	SET_DASHBOARD_FEATURE_BANNERS(state, payload) {
		state.dashboard.highlightCards = payload
			.sort((a, b) => {
				return a.displayOrder - b.displayOrder;
			})
			.map((item) => {
				return {
					icon: item.iconName,
					iconWeight: item.iconWeight,
					title: item.title,
					description: item.description,
					backgroundImage: item.backgroundImage,
					route: item.route,
				};
			});
	},
	// brand builder banner mutataions
	SET_BRANDBUILDER_BANNERS_LOADING_STATUS(state, status) {
		state.brandBuilder.loadingStatus = status;
	},
	SET_BRANDBUILDER_BANNERS_ERROR(state, message) {
		state.brandBuilder.error = message;
	},
	CLEAR_BRANDBUILDER_BANNERS_ERROR(state) {
		state.brandBuilder.error = '';
	},
	SET_BRANDBUILDER_FEATURE_BANNERS(state, payload) {
		state.brandBuilder.highlightCards = payload
			.sort((a, b) => {
				return a.displayOrder - b.displayOrder;
			})
			.map((item) => {
				return {
					icon: item.iconName,
					iconWeight: item.iconWeight,
					title: item.title,
					description: item.description,
					backgroundImage: item.backgroundImage,
					route: item.route,
				};
			});
	},
};
const actions = {
	// dashboard banner actions
	async getDashboardFeatureBanners({ commit }) {
		commit('SET_DASHBOARD_BANNERS_LOADING_STATUS', true);
		try {
			const response =
				await featureBannerServiceAPIClient.getFeatureBannersByTypeId(1);
			if (response && response.data) {
				const { data } = response;
				commit('SET_DASHBOARD_FEATURE_BANNERS', [...data]);
			} else {
				throw 'No feature banners returned from the API';
			}
		} catch (error) {
			commit(
				'SET_DASHBOARD_BANNERS_ERROR',
				'There was an error getting dashboard banners',
			);
		} finally {
			commit('SET_DASHBOARD_BANNERS_LOADING_STATUS', false);
		}
	},
	clearDashboardBannersError({ commit }) {
		commit('CLEAR_DASHBOARD_BANNERS_ERROR');
	},
	// brand builder banner actions
	async getBrandBuilderFeatureBanners({ commit }) {
		commit('SET_BRANDBUILDER_BANNERS_LOADING_STATUS', true);
		try {
			const response =
				await featureBannerServiceAPIClient.getFeatureBannersByTypeId(2);
			if (response && response.data) {
				commit('SET_BRANDBUILDER_FEATURE_BANNERS', [...response.data]);
			} else {
				throw 'No feature banners returned from the API';
			}
		} catch (error) {
			commit(
				'SET_BRANDBUILDER_BANNERS_ERROR',
				'There was an error getting brand builder banners',
			);
		} finally {
			commit('SET_BRANDBUILDER_BANNERS_LOADING_STATUS', false);
		}
	},
	clearBrandBuilderBannersError({ commit }) {
		commit('CLEAR_BRANDBUILDER_BANNERS_ERROR');
	},
};

export default {
	state,
	actions,
	mutations,
};
